import { PROGRAM_USERS_LIST, PROGRAM_USERS_LIST_SUCCESS, PROGRAM_USERS_LIST_ERROR, PROGRAM_USER_EMPTY } from './../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const ProgramUsers = (state = initialState, action) => {
  switch (action.type) {
    case PROGRAM_USERS_LIST:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case PROGRAM_USERS_LIST_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case PROGRAM_USERS_LIST_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case PROGRAM_USER_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default ProgramUsers;
